import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { updateClientBulkOrders } from 'api/bulkOrders.api';
import { getBulkOrdersByDateForClients } from 'api/clientbulkOrders.api';
import { IBulkOrdersState, IBulkOrderUpdateRequest, IBulkOrderWithItems } from 'domain/ClientBulkOrders';
import { handleThunkError } from 'utils/handleThunkError';

const initialState: IBulkOrdersState = {
  client_bulk_orders_list: [],
  client_bulk_orders_list_loaded: false,
};

export const fetchBulkOrdersByDateForClient = createAsyncThunk(
  'clientBulkOrders/GetBulkOrdersByDate',
  async (params: { selected_date: string }, { rejectWithValue }) => {
    try {
      const response = await getBulkOrdersByDateForClients(params);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const updateBulkOrderItems = createAsyncThunk(
  'ClientBulkOrders',
  async (data: IBulkOrderUpdateRequest, { rejectWithValue }) => {
    try {
      const response = await updateClientBulkOrders(data);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

const clientbulkOrdersSlice = createSlice({
  name: 'clientbulkOrders',
  initialState,
  reducers: {
    clearClientBulkOrders: (state) => {
      state.client_bulk_orders_list = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBulkOrdersByDateForClient.fulfilled, (state, action) => {
      state.client_bulk_orders_list_loaded = true;
      state.client_bulk_orders_list = action.payload.data.map((order: IBulkOrderWithItems) => ({
        ...order,
        recurrent_bulk_order_items: Array.isArray(order.recurrent_bulk_order_items)
          ? order.recurrent_bulk_order_items
          : JSON.parse(order.recurrent_bulk_order_items || '[]'),
      }));
    });
  }
});

export const { clearClientBulkOrders } = clientbulkOrdersSlice.actions;

export default clientbulkOrdersSlice.reducer;